var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chevron-down 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.2743 9.42502L11.352 15.738C11.589 15.9241 11.8112 16 12.0001 16C12.189 16 12.4435 15.9235 12.6146 15.7694L19.7256 9.42502C20.081 9.11127 20.0925 8.55618 19.7523 8.25622C19.4143 7.92436 18.8493 7.91357 18.4963 8.23144L12.0001 14.0279L5.50392 8.23553C5.15207 7.91768 4.58615 7.92847 4.24801 8.26031C3.90764 8.55618 3.91875 9.11127 4.2743 9.42502Z",
    fill: "#FCFCFC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.d29027aa9e3c1fc7827d8cdade5d07f8.svg";
export { ForwardRef as ReactComponent };